import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Icon from '@components/Icon/Icon';
import { EIcons } from '@enums/icons.enum';
import { EStyles } from '@enums/style.enum';
import { TimeFormat } from '@enums/timeFormat.enum';
import type { RootState } from '@store/store';
import { dayDurationHumanize } from '@utils/dayDurationHumanize';

import classes from './TripHeader.module.scss';

export const TripHeader: React.FC = () => {
	const distance = useSelector((state: RootState) => state.trips.currentTrip?.distance);
	const duration = useSelector((state: RootState) => state.trips.currentTrip?.duration);

	const { t } = useTranslation();

	return (
		<div className={classes['container']}>
			{distance && (
				<div className={classes['innerContainer']}>
					<Icon name={EIcons.Route} size={16} color="var(--medium)" />
					<p className={classes['text']}>
						{`${t('tripHeader.distance')}${EStyles.colon}`}
						<b> {`${(distance / 1000).toFixed(2)} ${t('tripHeader.kilometers')}`}</b>
					</p>
				</div>
			)}
			{duration && (
				<div className={classes['innerContainer']}>
					<Icon name={EIcons.Time} size={16} color="var(--medium)" />
					<p className={classes['text']}>
						{`${t('tripHeader.duration')}${EStyles.colon}`}
						<b> {`${dayDurationHumanize(duration).replace(TimeFormat.Minutes, t('tripHeader.minutesAbbreviation'))}`}</b>
					</p>
				</div>
			)}
		</div>
	);
};
